import { Button, Col, Modal, ModalBody, ModalHeader, Row } from 'reactstrap';
import { Form, Field } from 'react-final-form';
import { useDispatch } from 'react-redux';
import { actions } from '../../../../context';
import FieldTitle from '../../../Forms/FieldTitle';

const validDomain = (value) =>
        value && value.match(/[a-z]+\.[a-z]+/i)
            ? undefined
            : 'Must match format: "address.net"';
            
const NewDomain = ({ partnerId, refresh, toggle, isOpen = false }) => {
    const dispatch = useDispatch();
    
    const submit = async (vals) =>
        dispatch(actions.admin.createDomain({ ...vals }))
            .then((res) => {
                if (res) refresh();
            })
            .catch((err) => console.error(err))
            .finally(() => toggle());

    return (
        <Modal isOpen={isOpen} className="text-light" centered>
            <ModalHeader>New Domain</ModalHeader>
            <ModalBody>
                <Form
                    onSubmit={submit}
                    initialValues={{ id: partnerId }}
                    render={({
                        handleSubmit,
                        form,
                        submitting,
                        pristine,
                        values,
                    }) => (
                        <form onSubmit={handleSubmit}>
                            <Row>
                                <Col>
                                    <FieldTitle title="Domain" required />
                                    <Field
                                        name="name"
                                        validate={validDomain}
                                        placeholder="ex: 'gmail.com'">
                                        {({ input, meta, placeholder }) => (
                                            <div className="my-2">
                                                <input
                                                    className="w-100 rounded p-2 border"
                                                    {...input}
                                                    placeholder={placeholder}
                                                    type="text"
                                                />
                                                {meta.error && meta.touched && (
                                                    <div className="text-danger bg-light p-2 rounded">
                                                        {meta.error}
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </Field>
                                </Col>
                            </Row>
                            <Row>
                                <Col className="text-right">
                                    <Button color="danger" onClick={toggle}>
                                        Cancel
                                    </Button>
                                    <Button
                                        className="mx-2"
                                        type="submit"
                                        color="success"
                                        disabled={pristine || submitting}>
                                        Submit
                                    </Button>
                                </Col>
                            </Row>
                        </form>
                    )}></Form>
            </ModalBody>
        </Modal>
    );
};

export default NewDomain;
